import { useState } from "react";

import { IconButton, useTheme } from "@bps/fluent-ui";
import { usePermissionsCheckQuery } from "@libs/api/gateways/env/env-gateway.hooks";
import { NO_ACTION_PERMISSION } from "@libs/permissions/permissions.constants";
import { Permissions } from "@libs/permissions/permissions.enum";

import { JobsConfigurationJob } from "./dtos";
import { JobDialogHost } from "./job";

interface JobEditButtonProps {
  job: JobsConfigurationJob;
  onUpdateJob: (job: JobsConfigurationJob) => void;
}

export const JobEditButton: React.FC<JobEditButtonProps> = ({
  job,
  onUpdateJob
}) => {
  const theme = useTheme();
  const { data: hasDeployPermission } = usePermissionsCheckQuery(
    Permissions.PltFieldManagementDeploy
  );

  const [showEdit, setShowEdit] = useState(false);
  return (
    <>
      <JobDialogHost
        modeLabel="Edit"
        job={job}
        hidden={!showEdit}
        onDismiss={() => setShowEdit(false)}
        onSubmit={onUpdateJob}
      />
      <IconButton
        as="div"
        onClick={e => {
          e.stopPropagation();
          setShowEdit(true);
        }}
        iconProps={{
          iconName: "Edit"
        }}
        styles={{
          rootHovered: {
            borderColor: theme.semanticColors.listItemBackgroundCheckedHovered,
            background: theme.semanticColors.listItemBackgroundCheckedHovered
          }
        }}
        disabled={!hasDeployPermission}
        title={!hasDeployPermission ? NO_ACTION_PERMISSION : undefined}
      />
    </>
  );
};
